import type { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    position: 'relative',

    padding: '1.5rem',

    marginBottom: '-0.75rem',

    pointerEvents: 'none',
});

export const checkboxGroup: TRuleWithTheme = ({ theme }) => ({
    pointerEvents: 'none',
});

export const title: TRuleWithTheme = ({ theme }) => ({
    '&.ant-typography': {
        fontSize: '.75rem',
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginTop: '0.35rem',
        marginRight: '1rem',
    },
});

export const label: TRuleWithTheme = () => ({
    marginRight: '0.25rem',
});

export const checkbox: TRuleWithTheme = () => ({
    pointerEvents: 'all',
});
